export function BottomFinalRewardFrame(props: { colors?: [string, string] }) {
  const [color0, color1] = props.colors ?? ['#0B522D', '#66D58D']
  return (
    <svg
      viewBox="0 0 393 156"
      preserveAspectRatio="none"
      className="absolute top-0 block h-[156px] w-full rounded-t-[32px]"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        boxShadow: '0 -6px 10px 0 #00000040',
      }}
    >
      <g data-figma-bg-blur-radius={12}>
        <path
          d="M51.2002 1H341.8C350.777 1 357.45 1.00074 362.736 1.43262C368.01 1.86353 371.815 2.71894 375.073 4.37891C380.906 7.35098 385.649 12.0937 388.621 17.9268C390.281 21.1848 391.136 24.9897 391.567 30.2637C391.999 35.5496 392 42.2229 392 51.2002V155H1V51.2002L1.00684 44.8848C1.0273 38.9729 1.10871 34.2281 1.43262 30.2637C1.86353 24.9897 2.71894 21.1848 4.37891 17.9268C7.35098 12.0937 12.0937 7.35098 17.9268 4.37891C21.1848 2.71894 24.9897 1.86353 30.2637 1.43262C35.5496 1.00074 42.2229 1 51.2002 1Z"
          fill="url(#paint0_linear_20908_52451)"
          fillOpacity={0.8}
        />
        <path
          d="M51.2002 1H341.8C350.777 1 357.45 1.00074 362.736 1.43262C368.01 1.86353 371.815 2.71894 375.073 4.37891C380.906 7.35098 385.649 12.0937 388.621 17.9268C390.281 21.1848 391.136 24.9897 391.567 30.2637C391.999 35.5496 392 42.2229 392 51.2002V155H1V51.2002L1.00684 44.8848C1.0273 38.9729 1.10871 34.2281 1.43262 30.2637C1.86353 24.9897 2.71894 21.1848 4.37891 17.9268C7.35098 12.0937 12.0937 7.35098 17.9268 4.37891C21.1848 2.71894 24.9897 1.86353 30.2637 1.43262C35.5496 1.00074 42.2229 1 51.2002 1Z"
          stroke="url(#paint1_linear_20908_52451)"
          strokeWidth={2}
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_20908_52451"
          x1={196.5}
          y1={156}
          x2={196.5}
          y2={0}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={color0} />
          <stop offset={0.75} stopColor={color1} />
        </linearGradient>
        <linearGradient
          id="paint1_linear_20908_52451"
          x1={196}
          y1={-1.69071e-8}
          x2={196}
          y2={156}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity={0.7} />
          <stop offset={0.8} stopColor="white" stopOpacity={0.1} />
        </linearGradient>
      </defs>
    </svg>
  )
}
